module.exports = __webpack_public_path__ + "static/img/m_name.16508a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/sy/m_name.png
// module id = MFKb
// module chunks = 7